<template>
  <v-card elevation="0">
    <v-card-title class="pl-0"
      ><v-btn
        @click="$router.back()"
        color="secondaryAction"
        height="4em"
        class="rounded-lg pa-0 mr-4"
        ><v-icon color="white">mdi-chevron-left</v-icon></v-btn
      >
      {{ $t("register.accountSetup") }}</v-card-title
    >
    <v-form @submit="proceedIfValid" onSubmit="return false;">
      <v-text-field
        v-model="username"
        :label="$t('login.email')"
        single-line
        :rules="[() => !!username || $t('forms.thisFieldIsRequired')]"
        tabindex="1"
        dense
        outlined
        :error-messages="emailErrors"
      />
      <PasswordCreate v-model="password" @valid="setPasswordValid" />
      <v-btn tabindex="4" @click="proceedIfValid" block type="submit" color="primary">{{
        $t("register.next")
      }}</v-btn>
    </v-form>
  </v-card>
</template>
<script>
import { mapMutations } from "vuex";
import PasswordCreate from "@/components/Auth/PasswordCreate";
import debounce from "@/helpers/debounce";
import { SEARCH_USER } from "@/graphql/UserQueries";
export default {
  apollo: {
    emailExists: {
      query: SEARCH_USER,
      fetchPolicy: "network-only",
      variables() {
        return {
          email: this.queryUsername,
        };
      },
      update(data) {
        return data.users.edges.length > 0;
      },
      skip() {
        return !this.queryAllowed;
      },
    },
  },
  components: {
    PasswordCreate,
  },
  data() {
    return {
      username: "",
      password: "",
      repeatPassword: "",
      queryAllowed: false,
      queryUsername: '',
      passwordValid: false,
    };
  },
  computed: {
    validEmail() {
      return (this.username && this.username.indexOf("@") > 0 && this.username.length > 3)
    },
    emailErrors() {
      if (!this.validEmail && this.username.length > 3) {
        return this.$t('register.pleaseEnterValidEmail')
      }
      else if (this.emailExists) {
        return this.$t('register.emailInUse')
      }
      return null
    },
    valid() {
      if (this.emailErrors == null && this.passwordValid) {
        return true
      }
      return false
    }
  },
  methods: {
    ...mapMutations("auth/registration", ["setEmail", "setPassword"]),
    registerAction() {
      this.register({ username: this.username, password: this.password });
    },
    setPasswordValid(value) {
      this.passwordValid = value
    },
    proceedIfValid() {
      if (this.valid) {
        this.setEmail(this.username)
        this.setPassword(this.password)
        this.$router.push('register/profile')
      }
    },
  },
  watch: {
    username: debounce(function () {
      if (this.validEmail) {
        this.queryAllowed = true;
        this.queryUsername = this.username
      }
      else {
        this.queryAllowed = false;
      }
    }, 500),
  },
};
</script>
<style lang="scss" scoped>
</style>